import { useRoutes } from "react-router-dom";
import { BusinessApp } from "@rewardle/apps.businessapp";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { authedRoutes, unAuthedRoutes, unAuthorisedlayout } from "./routes";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_databaseURL,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  appId: process.env.REACT_APP_FIREBASE_appId
};

const baseUrl: any = process.env.REACT_APP_API_BASE_MENU_URL;

function App() {
  const [userDetails, setUserDetails] = useState<any>(null);

  const renderRoutes = () => {
    let pageRoutes = [];
    const authenticatedRoutes = authedRoutes.map((route) => ({
      ...route,
      element: React.cloneElement(route.element, { userDetails })
    }));

    pageRoutes = userDetails?.token
      ? userDetails?.isAuthenticated && userDetails?.isAuthorized
        ? authenticatedRoutes
        : unAuthorisedlayout
      : unAuthedRoutes;

    return pageRoutes;
  };

  const routes = useRoutes(renderRoutes());
  const navigate = useNavigate();

  console.log("this is window", window?.location?.pathname?.split("/")[1]);

  return (
    <BusinessApp
      firebaseConfig={firebaseConfig}
      apiDomain={baseUrl}
      navigate={navigate}
      setUserDetails={setUserDetails}
    >
      {routes}
    </BusinessApp>
  );
}

export default React.memo(App);
